<!--
 * @Description: 添加线下作业
 * @Author: PF
 * @Date: 2024-01-31 09:57:23
 * @LastEditors: PF
 * @LastEditTime: 2024-07-24 14:44:56
-->
<template>
  <div>
    <el-dialog class="wp85 hp85" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加线下作业情况</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学期" prop="xqid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.xqid" clearable filterable :teleported="false" @change="initBanJi();initZhouCi()">
                <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="班级" prop="bjid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.bjid" clearable filterable :teleported="false" @change="initKeCheng();initBanJiXueSheng()">
                <el-option v-for="item in bjData" :key="item.bjid" :label="item.bjmc" :value="item.bjid" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程" prop="kcid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.kcid" clearable filterable :teleported="false" @change="initJiaoXueDanYuan()">
                <el-option v-for="item in kcData" :key="item.kcid" :label="item.kcmc" :value="item.kcid" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="周次" prop="zc" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.zc" clearable filterable :teleported="false" >
                <el-option v-for="item in zcData" :key="item.zc" :label="'第'+item.zc+'周'" :value="item.zc" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="星期" prop="xq" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.xq" clearable filterable :teleported="false" >
                <el-option label="星期一" :value="1" />
                <el-option label="星期二" :value="2" />
                <el-option label="星期三" :value="3" />
                <el-option label="星期四" :value="4" />
                <el-option label="星期五" :value="5" />
                <el-option label="星期六" :value="6" />
                <el-option label="星期日" :value="7" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="节次" prop="jc" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.jc" clearable filterable :teleported="false" >
                <el-option v-for="item in jcData" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学单元" prop="jxdyid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.jxdyid" filterable clearable :teleported="false" @change="initJiaoXueNeiRong()">
                <el-option v-for="item in jxdyData" :key="item.id" :label="item.jxdybt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学内容" prop="jxnrid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.jxnrid" filterable clearable :teleported="false" >
                <el-option v-for="item in jxnrData" :key="item.id" :label="item.jxnrbt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布时间" prop="bzsj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.bzsj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="截止时间" prop="jzsj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.jzsj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总分" prop="xianXiaZuoYe.zf" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.xianXiaZuoYe.zf" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否计入平时成绩" prop="sfjrpscj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-switch v-model="ruleForm.sfjrpscj" style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="作业名称" prop="xianXiaZuoYe.zymc" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.xianXiaZuoYe.zymc" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="作业内容" prop="xianXiaZuoYe.zynr" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <teditor ref="editor" v-model="ruleForm.xianXiaZuoYe.zynr" :height="200" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>学生完成情况</el-divider>

        <el-table :data="ruleForm.xueShengZuoYePiGai" border stripe>
          <!-- 冻结列-Left BEGIN -->
          <el-table-column label="序号" type="index" width="80" fixed align="center" />
          <!-- 冻结列-Left END -->
          <el-table-column label="姓名" prop="xm" align="center" show-overflow-tooltip />
          <el-table-column label="是否完成" align="center" show-overflow-tooltip>
            <template #default="scope">
              <el-checkbox v-model="scope.row.sfwc" />
            </template>
          </el-table-column>
          <el-table-column label="分数" align="center" show-overflow-tooltip>
            <template #default="scope">
              <el-input-number v-model="scope.row.zdf" :min="0" />
            </template>
          </el-table-column>
          <el-table-column label="评价" align="center" show-overflow-tooltip>
            <template #default="scope">
              <el-input v-model="scope.row.py" class="wp100 hp100" type="textarea" resize="none" />
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import {
  submitForm,
  actionPost,
  closeWindow,
  loadSelect
} from '@/api/common.js'
import teditor from '@/components/teditor.vue'

const props = defineProps({ openAdd: { type: Boolean, required: true }, row: { required: false } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({ sfjrpscj: false, xianXiaZuoYe: {}, xueShengZuoYePiGai: [] })

// 加载 学期 下拉框
const xqData = ref()
const initXueQi = () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: xqData,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          ruleForm.value.xqid = element.id
          initZhouCi()
          initBanJi()
        }
      })
    }
  })
}

// 加载 班级 下拉框
const bjData = ref()
const initBanJi = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/xueshengzuoye/huoqujiaoshisuojiaobanji',
    data: bjData,
    parms: { xqid: ruleForm.value.xqid, order: 'bjmc', sort: 'asc' }
  })
}

// 加载 课程 下拉框
const kcData = ref()
const initKeCheng = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/xueshengzuoye/huoqujiaoshisuojiaokecheng',
    data: kcData,
    parms: { xqid: ruleForm.value.xqid, bjid: ruleForm.value.bjid, order: 'xzbdm', sort: 'asc' }
  })
}

// 加载 周次 下拉框
const zcData = ref([])
const initZhouCi = () => {
  const o = {
    url: '/api/v2/jiaowu/jiaowuxiaoli/xiaoLiRiQi',
    data: { xqid: ruleForm.value.xqid }
  }
  const zcs = []
  zcData.value = []
  actionPost(o).then((res) => {
    if (res.data) {
      res.data.forEach((item) => {
        if (zcs.indexOf(item.zc) === -1) {
          zcs.push(item.zc)
          zcData.value.push(item)
        }
      })
    }
  })
}

// 加载 节次 下拉框
const jcData = ref()
const initJieCi = () => {
  jcData.value = []
  actionPost({ url: '/api/v2/jiaowu/jiaowukebiaojiegou/list' }).then((res) => {
    if (res.data) {
      for (let index = 1; index <= res.data.zjc; index++) {
        jcData.value.push({ value: index, label: '第' + index + '节' })
      }
    }
  })
}
// 加载 教学单元 下拉框
const jxdyData = ref()
const initJiaoXueDanYuan = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
    data: jxdyData,
    parms: { kcid: ruleForm.value.kcid, order: 'sx', sort: 'asc' }
  })
}
// 加载 教学内容 下拉框
const jxnrData = ref()
const initJiaoXueNeiRong = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
    data: jxnrData,
    parms: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' }
  })
}
// 学生完成情况
const initBanJiXueSheng = () => {
  actionPost({ url: '/api/v2/ziyuanku/xueshengzuoye/huoqubanjiaxiadexuesheng', data: { bjid: ruleForm.value.bjid, order: 'xh', sort: 'asc' } }).then((res) => {
    if (res.data) {
      ruleForm.value.xueShengZuoYePiGai = res.data || []
    }
  })
}
const row = ref()
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      row.value = props.row
      initXueQi()
      initJieCi()
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  ruleForm.value.xueShengZuoYePiGai = ruleForm.value.xueShengZuoYePiGai.map(item => ({ xsid: item.id, xm: item.xm, sfwc: item.sfwc || false, zdf: item.zdf || null, py: item.py || null }))
  submitForm({
    url: '/api/v2/ziyuanku/xueshengzuoye/tianjiaxianshangzuoye',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
